import {ChangeDetectionStrategy, Component} from '@angular/core'
import {LinkService, OTHER_OFFERING_ID} from '../../../../../core/i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../../shared/routing/public.routes'

@Component({
  selector: 'bgo-region-directory-sidenav-direct-links',
  templateUrl: './region-directory-sidenav-direct-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      @reference '../../../../../../styles/app-reference.css';

      :host {
        @apply block pb-3xl;
      }
    `,
  ],
})
export class RegionDirectorySidenavDirectLinksComponent {
  protected readonly otherJobRequestLink = this.linkService.localizedPathTo(PUBLIC_ROUTES.JOB_REQUEST, {
    routeParams: {offeringId: OTHER_OFFERING_ID},
  })
  protected readonly magazineLink = this.linkService.localizedPathTo(PUBLIC_ROUTES.ARTICLE_OVERVIEW)
  protected readonly searchLink = this.linkService.searchPath

  constructor(protected linkService: LinkService) {}
}
